var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svg)?_c('div',{staticClass:"clv-svg",attrs:{"role":"img","aria-label":"Clover Image"},domProps:{"innerHTML":_vm._s(_vm.svg)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }